export const environment = {
  production: false,
  ENV: 'DEV',
  API: 'https://claim-dev.apps.hq1.nxb.vsp.com/reference-inventoryportalapi/inventoryportalitems',
  oauthApiUrl: 'https://api-integration.vsp.com',
  oauthClientId: 'reference-inventoryportal-ui',
  oauthRedirectUrl: 'https://inventory-dev.pub.vsp.com/oauth_callback',
  oauthScopes: 'auth_employee_sso openid profile reference_view write:vc.reference.inventory',
  openIdUrl: 'https://api-integration.vspglobal.com/idp/userinfo.openid',
  requiredAdGroups: []
};
